import React, { useMemo, useState } from 'react';
import { BiCheckbox } from 'react-icons/bi';
import { BsGrid } from 'react-icons/bs';
import { FaChevronDown, FaChevronLeft } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger, useDisclosure
} from '@chakra-ui/react';

import { selectCompanyFeatures, selectCompanySettings } from '../../../redux/modules/company';
import colors from '../../../styles/theme/foundation/colors';
import { activeStyle, hoverStyle, popoverMenuButtonStyles } from '../../../styles/theme/util/popoverMenuButtonStyles';
import { createMap } from '../../../utils/arrayUtil';

import DropdownButton from './DropdownButton';
import PropertyDropdownItem from './PropertyDropdownItem';

const PropertyDropdown = ({ searchBlueprint, filter }) => {
  const dispatch = useDispatch();
  const advancedFilterOptions = useSelector(searchBlueprint.selectAdvancedFilterOptions);
  const [parentProperty, setParentProperty] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const companyFeatures = useSelector(selectCompanyFeatures);
  const companyFeaturesMap = useMemo(() => createMap(companyFeatures, 'name'), [companyFeatures]);
  const companySettings = useSelector(selectCompanySettings);
  const companySettingsMap = useMemo(() => createMap(companySettings, 'name'), [companySettings]);

  const isDisabled = !!filter.value;

  const content = parentProperty
    ? (
      <Box>
        <DropdownButton
          leftIcon={FaChevronLeft}
          text={parentProperty.name}
          onClick={() => setParentProperty(null)}
        />
        {parentProperty.subProperties.map((property, index = 1) => (
          <PropertyDropdownItem
            icon={BiCheckbox}
            isHidden={companySettingsMap[property?.setting] ? !companySettingsMap[property?.setting].isEnabled : false}
            key={property.name}
            text={property.name}
            onClick={() => {
              onClose();
              dispatch(searchBlueprint.updateStagedFilterProperty(
                parentProperty.name,
                property.name
              ));
            }}
          />
        ))}
      </Box>
    )
    : (
      <Box>
        <PropertyDropdownItem icon={BsGrid} text="All Properties" />
        {advancedFilterOptions
          .filter(filter => (filter.featureFlag ? companyFeaturesMap[filter.featureFlag]?.isEnabled : true))
          .map(property => (
            <PropertyDropdownItem
              icon={property.icon}
              key={property.name}
              subProperties={property.subProperties}
              text={property.name}
              onClick={() => property.subProperties.length && setParentProperty(property)}
            />
          ))}
      </Box>
    );

  const label = filter?.property?.entity
    ? `${filter.property.entity} ${filter.property.name}`
    : filter?.property?.name || 'Property';

  return (
    <Box
      flex={1}
      mb="20px"
      position="relative"
    >
      <Popover
        isOpen={isOpen}
        maxW="100%"
        placement="bottom"
        variant="expand"
        onClose={onClose}
        onOpen={onOpen}
      >
        <PopoverTrigger>
          <Button
            _active={activeStyle}
            _hover={hoverStyle}
            color={label === 'Property' ? colors.greyScale['500'] : colors.greyScale['900']}
            isDisabled={isDisabled}
            style={popoverMenuButtonStyles}
            variant="unstyled"
          >
            {label}
            {!isDisabled && <Icon as={FaChevronDown} boxSize={4} />}
          </Button>
        </PopoverTrigger>
        <PopoverContent width="100%">
          <PopoverBody p="10px">
            {content}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

PropertyDropdown.propTypes = {};

export default PropertyDropdown;
